import * as Yup from 'yup';

export enum FORM_FIELDS {
	FIRST_NAME = 'firstName',
	LAST_NAME = 'lastName',
	EMAIL = 'email',
	PHONE = 'phone',
	MERCHANT_ID = 'merchantId',
	IS_MASKED_PII = 'IsPiiMasked'
}

export enum FORM_FIELDS_NAMES {
	FIRST_NAME = 'First name',
	LAST_NAME = 'Last name',
	EMAIL = 'Email',
	PHONE = 'Phone',
	MERCHANT_ID = 'Merchant',
	IS_MASKED_PII = 'Mask PII'
}

export enum ROLE {
	MERCHANT_ADMIN = 'MERCHANT_ADMIN',
	MERCHANT_SUPPORT = 'MERCHANT_SUPPORT',
	MERCHANT_SUPPORT_ADMIN = 'MERCHANT_SUPPORT_ADMIN',
	MERCHANT_FINANCE = 'MERCHANT_FINANCE',
	MERCHANT_DEVELOPER = 'MERCHANT_DEVELOPER',
}

export const ROLES = [
	{
		value: ROLE.MERCHANT_ADMIN,
		label: 'Administrator',
		description: 'Best for business owners and company administrators'
	},
	{
		value: ROLE.MERCHANT_SUPPORT,
		label: 'Customer service',
		description: 'Best for employees who need an overview of the orders and refunds'
	},
	{
		value: ROLE.MERCHANT_SUPPORT_ADMIN,
		label: 'Customer service + refunds',
		description: 'Best for employees who need an overview of the orders and need to issue refunds'
	},
	{
		value: ROLE.MERCHANT_FINANCE,
		label: 'Accounting',
		description: 'Best for people who need to preview content data, but don\'t need to make any updates'
	},
	{
		value: ROLE.MERCHANT_DEVELOPER ,
		label: 'Developer',
		description: 'Best for developers or people primarily using the API'
	},
];

export const userSuperAdminDetailsSchema = Yup.object().shape({
	[FORM_FIELDS.FIRST_NAME]: Yup.string()
		.required(`${FORM_FIELDS_NAMES.FIRST_NAME} is required`),
	[FORM_FIELDS.LAST_NAME]: Yup.string()
		.required(`${FORM_FIELDS_NAMES.LAST_NAME} is required`),
	[FORM_FIELDS.EMAIL]: Yup.string()
		.email(`${FORM_FIELDS_NAMES.EMAIL} should be valid`)
		.required(`${FORM_FIELDS_NAMES.EMAIL} is required`),
	[FORM_FIELDS.PHONE]: Yup.number()
		.test('is-valid-phone', 'Enter a valid phone number', (value) => {
      if (!value) return true;
      const phoneRegex = /^[0-9]{10,15}$/;
      return phoneRegex.test(value.toString());
    })
		.typeError('You must specify a number')
		.required(`${FORM_FIELDS_NAMES.PHONE} is required`),
	[FORM_FIELDS.MERCHANT_ID]: Yup.string()
		.required(`${FORM_FIELDS_NAMES.MERCHANT_ID} is required`),
});

export const userMerchantDetailsSchema = Yup.object().shape({
	[FORM_FIELDS.FIRST_NAME]: Yup.string()
		.required(`${FORM_FIELDS_NAMES.FIRST_NAME} is required`),
	[FORM_FIELDS.LAST_NAME]: Yup.string()
		.required(`${FORM_FIELDS_NAMES.LAST_NAME} is required`),
	[FORM_FIELDS.EMAIL]: Yup.string()
		.email(`${FORM_FIELDS_NAMES.EMAIL} should be valid`)
		.required(`${FORM_FIELDS_NAMES.EMAIL} is required`),
	[FORM_FIELDS.PHONE]: Yup.number()
		.test('is-valid-phone', 'Enter a valid phone number', (value) => {
      if (!value) return true;
      const phoneRegex = /^[0-9]{10,15}$/;
      return phoneRegex.test(value.toString());
    })
		.typeError('You must specify a number')
		.required(`${FORM_FIELDS_NAMES.PHONE} is required`),
});

export type IUserDetails = {
	[key in FORM_FIELDS]: string | Date | boolean;
};

export type IUserFieldsReturnTypes = {
	firstName: string,
	lastName: string,
	email: string,
	phone: string | number,
	merchantId?: string,
	group?: string,
	isPiiMasked: boolean,
}

export const initialValues = {
	[FORM_FIELDS.FIRST_NAME]: '',
	[FORM_FIELDS.LAST_NAME]: '',
	[FORM_FIELDS.EMAIL]: '',
	[FORM_FIELDS.PHONE]: '',
	[FORM_FIELDS.MERCHANT_ID]: '',
	[FORM_FIELDS.IS_MASKED_PII]: false,
};

export const convertToInitial = (data): IUserDetails => ({
	[FORM_FIELDS.FIRST_NAME]: data?.firstName,
	[FORM_FIELDS.LAST_NAME]: data?.lastName,
	[FORM_FIELDS.EMAIL]: data?.email,
	[FORM_FIELDS.PHONE]: data?.phone,
	[FORM_FIELDS.MERCHANT_ID]: data?.merchantId,
	[FORM_FIELDS.IS_MASKED_PII]: data?.isPiiMasked,
});

export const getFormattedUsersData = (formikValues): IUserFieldsReturnTypes => ({
	firstName: formikValues?.[FORM_FIELDS.FIRST_NAME],
	lastName: formikValues?.[FORM_FIELDS.LAST_NAME],
	phone: formikValues?.[FORM_FIELDS.PHONE],
	email: formikValues?.[FORM_FIELDS.EMAIL],
	isPiiMasked: formikValues?.[FORM_FIELDS.IS_MASKED_PII],
	// userName: formikValues?.[FORM_FIELDS.EMAIL],
});

export const getFormattedInitialUserData = (data): IUserFieldsReturnTypes => ({
	firstName: data?.firstName,
	lastName: data?.lastName,
	phone: data?.phone,
	email: data?.email,
	merchantId: data?.merchantId,
	group: data?.group,
	isPiiMasked: data?.isPiiMasked,
});

export enum USER_TABS {
	USER_INFO = 'personal-information',
	ACCOUNT_SECURITY = 'security',
	ACCOUNT = 'account'
}
